var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{attrs:{"id":"methodology-editions"}},[_c('section',{attrs:{"id":"editions"}},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.currentLangDict.title))]),_c('monitorings')],1)]),_c('section',{attrs:{"id":"methodology"},domProps:{"innerHTML":_vm._s(_vm.currentLangDict.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }